import { memo, useEffect, useState, useRef } from "react";
import { Button, Form, FormInstance, InputNumber, Modal } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { Worker, WorkerPosition } from "../../Models/Worker";
import {
  Page,
  View,
  Text,
  Document,
  PDFDownloadLink,
  StyleSheet,
} from "@react-pdf/renderer";

interface WorkerWithShift extends Worker {
  shifts: string[];
}

interface Props {
  workers: Worker[];
}

interface FormProps {
  form: FormInstance<any>;
  onFinish: (values: any) => void;
  initialValues: any;
  onSumChange: (sum: number) => void;
}
const ModalForm = (props: FormProps) => {
  function handleFinish(values: any) {
    console.log(values);
    props.onFinish(values);
  }

  const handleChange = (changedValue: any, allValues: any) => {
    let sum = 0;
    Object.values(allValues).forEach((value: any) => {
      sum += value as number;
    });
    console.log(sum);
    props.onSumChange(sum);
  };

  useEffect(() => {
    props.form.resetFields();
  }, [props.initialValues]);

  return (
    <Form
      form={props.form}
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 14 }}
      layout="horizontal"
      initialValues={props.initialValues}
      onFinish={handleFinish}
      onValuesChange={handleChange}
    >
      <Form.Item label="Pakendajaid" name="pakendajaid">
        <InputNumber min={0} />
      </Form.Item>
      <Form.Item label="Sulgejaid" name="sulgejaid">
        <InputNumber min={0} />
      </Form.Item>
      <Form.Item label="Kaalujaid" name="kaalujaid">
        <InputNumber min={0} />
      </Form.Item>
      <Form.Item label="Vastuvõtjaid" name="vastuvotjaid">
        <InputNumber min={0} />
      </Form.Item>
      <Form.Item label="Kühveldajaid" name="kyhveldajaid" key={"kyhveldajaid"}>
        <InputNumber min={0} />
      </Form.Item>
    </Form>
  );
};

function GenerateScheduleModal(props: Props) {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const [sum, setSum] = useState(props.workers.length);
  const [initialValues, setInitialValues] = useState<any>({});
  const showModal = () => {
    setVisible(true);
  };
  const [shifts, setShifts] = useState<any[]>([]);
  const buttonRef = useRef(null);

  useEffect(() => {
    setSum(props.workers.length);
    setInitialValues(calculateInitialValues());
  }, [props.workers]);

  useEffect(() => {
    if (shifts.length === 4) {
      console.log("TEST");
      // @ts-ignore
      setTimeout(() => {
        buttonRef?.current?.click();
      }, 1000);
    }
    console.log("TEST");
  }, [shifts]);

  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    console.log("Clicked cancel button");
    setVisible(false);
  };

  const handleModalDestroy = () => {
    // form.resetFields();
  };

  const calculateInitialValues = () => {
    const len = props.workers.length;
    console.log("LENGTH", len);
    let pakendajaid = 1;
    let sulgejaid = 1;
    let kaalujaid = 1;
    let vastuvotjaid = 1;
    let kyhveldajaid = 1;

    if (len >= 6) {
      kaalujaid += 1;
      console.log(6);
    }
    if (len >= 7) {
      vastuvotjaid += 1;
      console.log(7);
    }
    if (len >= 8) {
      kyhveldajaid += 1;
    }
    if (len >= 9) {
      kaalujaid += 1;
    }
    if (len >= 10) {
      vastuvotjaid += 1;
    }
    if (len >= 11) {
      sulgejaid += 1;
    }
    if (len >= 12) {
      vastuvotjaid += 1;
    }
    if (len >= 13) {
      kaalujaid += 1;
    }
    if (len >= 14) {
      vastuvotjaid += 1;
    }
    if (len >= 15) {
      kyhveldajaid += 1;
    }
    if (len >= 16) {
      kyhveldajaid += 1;
    }
    return {
      sulgejaid,
      kaalujaid,
      kyhveldajaid,
      vastuvotjaid,
      pakendajaid,
    };
  };

  function shuffleArray(array: any[]) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]]; // Swap elements
    }
    return array;
  }

  const assignPosition = (
    worker: WorkerWithShift,
    positions: any,
    pos: number,
    checkLevel: number
  ): any => {
    console.log(positions);
    let keys = shuffleArray(Object.keys(positions));
    let found = false;
    let foundKey = "tere";
    keys.forEach((key) => {
      if (found || positions[key] <= 0) {
        console.log("skip", key, positions);
      } else {
        if (
          !worker.shifts.includes(key) ||
          (checkLevel > 0 &&
            worker.shifts[worker.shifts.length - checkLevel] !== key)
        ) {
          worker.shifts.push(key);
          found = true;
          foundKey = key;
          console.log(found, worker, key, positions);
        }
      }
    });
    //  if (!checkLevel) {
    // assignPosition(worker, positions, pos, checkLevel + 1);
    // }

    if (checkLevel > 4) {
      console.log("OVER 1000", worker, positions, pos, checkLevel);
      return "Hello";
    }
    if (!found) {
      return assignPosition(worker, positions, pos, checkLevel + 1);
    } else {
      return foundKey;
    }
  };

  const onFinish = (values: any) => {
    const numberOfShifts = 4;
    let workerCopy: WorkerWithShift[] = props.workers.map((w) => ({
      ...w,
      shifts: [],
    }));

    let shuffled = shuffleArray(workerCopy);
    let error = false;
    for (let i = 0; i < numberOfShifts; i++) {
      let copyValues = { ...values };
      shuffled = shuffleArray(shuffled);
      let notFound = [];
      let found = 0;
      for (let pos = 0; pos < sum; pos++) {
        let worker = shuffled[pos];
        let positionTakenKey = assignPosition(worker, copyValues, pos, 0);
        console.log("FOUND KEY", positionTakenKey);
        if (positionTakenKey) {
          copyValues[positionTakenKey] -= 1;
        } else {
          console.log("WTFFFF");
          error = true;
          break;
        }
      }
    }

    let tempShifts: any[] = [];
    workerCopy.forEach((w) => {
      for (let i = 0; i < numberOfShifts; i++) {
        if (tempShifts.length === i) {
          tempShifts.push({});
        }
        if (tempShifts[i][w.shifts[i]]) {
          tempShifts[i][w.shifts[i]].push(w);
        } else {
          tempShifts[i][w.shifts[i]] = [w];
        }
      }
    });
    setShifts(tempShifts);
  };

  return (
    <>
      <Button type="primary" icon={<PlusOutlined />} onClick={showModal}>
        Koosta graafk
      </Button>
      <Modal
        width={800}
        title="Koosta graafikl"
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        afterClose={handleModalDestroy}
        okText={"Koosta"}
        cancelText={"Tühista"}
        destroyOnClose={true}
        okButtonProps={{
          disabled: sum !== props.workers.length,
        }}
      >
        <ModalForm
          form={form}
          onFinish={onFinish}
          initialValues={initialValues}
          onSumChange={setSum}
        />
        <PDFDownloadLink
          document={<MyDocument shifts={shifts} />}
          fileName="Graafik.pdf"
        >
          {({ loading }) => (
            <Button ref={buttonRef} style={{ display: "none" }}></Button>
          )}
        </PDFDownloadLink>
        {sum !== props.workers.length && (
          <span style={{ color: "red" }}>
            {" "}
            Töötajate arv ei klapi {sum} vs {props.workers.length}
          </span>
        )}
      </Modal>
    </>
  );
}
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#E4E4E4",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
});

interface PDFProps {
  shifts: any[];
}
// Create PDF Document Component
const MyDocument = (props: PDFProps) => {
  if (props.shifts.length === 0) return null;
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text>Kell 08:00 - 10:00</Text>
          {Object.keys(props.shifts[0])
            .sort()
            .map((key) => {
              return (
                <Text key={key + 0}>
                  {key.replace("i", "")}
                  {": "}
                  {props.shifts[0][key].map((w: any) => w.name).join(", ")}
                </Text>
              );
            })}
        </View>
        <View style={styles.section}>
          <Text>Kell 10:00 - 12:00</Text>
          {Object.keys(props.shifts[1])
            .sort()
            .map((key) => {
              return (
                <Text key={key + 1}>
                  {key.replace("i", "")}
                  {": "}
                  {props.shifts[1][key].map((w: any) => w.name).join(", ")}
                </Text>
              );
            })}
        </View>
        <View style={styles.section}>
          <Text>Kell 12:00 - 14:00</Text>
          {Object.keys(props.shifts[2])
            .sort()
            .map((key) => {
              return (
                <Text key={key + 2}>
                  {key.replace("i", "")}
                  {": "}
                  {props.shifts[2][key].map((w: any) => w.name).join(", ")}
                </Text>
              );
            })}
        </View>
        <View style={styles.section}>
          <Text>Kell 14:00 - 16:00</Text>
          {Object.keys(props.shifts[3])
            .sort()
            .map((key) => {
              return (
                <Text key={key + 3}>
                  {key.replace("i", "")}
                  {": "}
                  {props.shifts[3][key].map((w: any) => w.name).join(", ")}
                </Text>
              );
            })}
        </View>
      </Page>
    </Document>
  );
};

export default GenerateScheduleModal;
